import { render, staticRenderFns } from "./CsrfToken.vue?vue&type=template&id=9596f010&"
import script from "./CsrfToken.vue?vue&type=script&lang=js&"
export * from "./CsrfToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports